import { render, staticRenderFns } from "./role-form.vue?vue&type=template&id=41d4214c&scoped=true&"
import script from "./role-form.vue?vue&type=script&lang=js&"
export * from "./role-form.vue?vue&type=script&lang=js&"
import style0 from "./role-form.vue?vue&type=style&index=0&id=41d4214c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4214c",
  null
  
)

export default component.exports